import React from 'react';
import { Typography } from '@material-ui/core';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { useStyles } from './styles';

const IconLink = (props: {
  component?: any;
  startIcon?: any;
  endIcon?: any;
  children?: any;
  to?: string;
  title?: string;
  customClass?: any;
}) => {
  const {
    component: Component,
    startIcon,
    endIcon,
    children,
    customClass,
    ...rest
  } = props;
  const classes = useStyles();

  const cssClasses = clsx({
    [classes.root]: true,
    [customClass]: customClass,
  });

  return (
    <Typography
      component={Component}
      className={cssClasses}
      variant="body1"
      {...rest}
    >
      {startIcon}
      {children}
      {endIcon}
    </Typography>
  );
};

IconLink.defaultProps = {
  to: null,
  title: null,
  customClass: null,
  component: Link,
  startIcon: null,
  children: null,
  endIcon: null,
};

export default IconLink;
